import { render } from "./BurgerMenu.vue?vue&type=template&id=cf0640a8&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=cf0640a8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf0640a8"

export default script